import styled from "styled-components";
const MyDiv = styled.div`
.card_wrapper {
  border-radius: 12px;
  overflow: hidden;
  background: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
}

.flex_header {
  align-items: center;
  justify-content: space-between;
}
`
export default MyDiv